module.exports = __webpack_public_path__ + "img/BASLogo_Color.e5c0165c.svg";